const $ = jQuery;

export default {
    init() {
        setupSeamlessMarquee();
    }
};

function setupSeamlessMarquee() {
    const $blocks = $('.page-block-teams-carousel');

    if (!$blocks.length) return;

    $blocks.each(function() {
        const $container = $(this);
        const $slider = $container.find('.team-slider');
        const $prevArrow = $container.find('.teams-prev-custom');
        const $nextArrow = $container.find('.teams-next-custom');
        const $viewport = $slider.parent();

        if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
        }

        $viewport.css({
            'overflow': 'hidden',
            'width': '100%'
        });

        $slider.css({
            'display': 'flex',
            'flexWrap': 'nowrap',
            'width': 'max-content',
            'willChange': 'transform',
            'alignItems': 'stretch'
        });

        const originalCount = $slider.children().length;
        const originalHtml = $slider.html();

        for (let i = 0; i < 9; i++) {
            $slider.append(originalHtml);
        }

        let singleSetWidth = 0;

        function updateWidths() {
            const winW = $(window).width();
            let cols = 6;
            if (winW < 779) cols = 2;
            else if (winW < 992) cols = 3;
            else if (winW < 1280) cols = 4;

            const itemW = $viewport.width() / cols;

            $slider.children().css({
                'width': itemW + 'px',
                'flexShrink': 0,
                'display': 'flex',
                'flexDirection': 'column',
                'justifyContent': 'start'
            });

            singleSetWidth = itemW * originalCount;
        }

        updateWidths();
        $(window).on('resize', updateWidths);

        let speed = 1.5; // Higher number = faster scroll
        let direction = 1; // 1 = Left (Next), -1 = Right (Prev)

        let position = -(singleSetWidth * 4);
        let isHovered = false;

        function tick() {
            if (!isHovered && singleSetWidth > 0) {
                position -= (speed * direction);

                if (position <= -(singleSetWidth * 5)) {
                    position += singleSetWidth;
                } else if (position >= -(singleSetWidth * 3)) {
                    position -= singleSetWidth;
                }

                $slider.css('transform', `translateX(${position}px)`);
            }
            requestAnimationFrame(tick);
        }

        tick();

        $slider.on('mouseenter', () => isHovered = true);
        $slider.on('mouseleave', () => isHovered = false);

        $prevArrow.on('click', function(e) {
            e.preventDefault();
            direction = -1;
        });

        $nextArrow.on('click', function(e) {
            e.preventDefault();
            direction = 1;
        });
    });
}
